import { useTranslation } from 'react-i18next';
import { SocialPostType } from '@anytag/graphql';
import { DownloadButton } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { PostsList, PostsFilter, usePostsFilter } from '@anytag/shared-organisms';
import { DownloadCsvPagesAndRowsModal, Header, ListWithPagination } from '@anytag/shared-molecules';
import { usePostsData, usePostsCsvDownload } from './hooks';

const MAX_CSV_ROWS_EXPORT_FOR_POSTS = 10000;

export const Posts = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Posts Search', appHeader: 'appHeader.Posts Search' });
  const { t } = useTranslation();
  const { limit, filter } = usePostsFilter();
  const { posts, loading, totalRecords } = usePostsData();
  const { downloadModal, downloading, handlePostsCsvDownload } = usePostsCsvDownload();

  return (
    <div>
      <Header>
        <DownloadButton title={t('CSV Download')} className="ml-auto" onClick={downloadModal.open} />
      </Header>

      <ListWithPagination pagination={{ totalRecords }}>
        <PostsFilter />
        <PostsList
          data={posts}
          loading={loading}
          totalRecords={totalRecords}
          hasSimilarPosts={filter.socialMedia === SocialPostType.INSTAGRAM}
        />
      </ListWithPagination>

      <DownloadCsvPagesAndRowsModal
        limit={limit}
        downloading={downloading}
        open={downloadModal.status}
        onClose={downloadModal.close}
        onSubmit={handlePostsCsvDownload}
        maxRows={MAX_CSV_ROWS_EXPORT_FOR_POSTS}
      />
    </div>
  );
};
